import { useNavigate } from "react-router-dom";
import Styles from "./LandingPage.module.css";
import { PiInstagramLogoBold } from "react-icons/pi";
import { RiFacebookFill, RiMoneyDollarCircleFill } from "react-icons/ri";
import AccordionItem from "../../Components/AccordianItem";
import { FAQS_TRT2 } from "../../Model/FaqModel";
import { useEffect, useRef, useState } from "react";
import Testimonial from "../Home/Testimonial";
import { Testimonials_Model } from "../../Model/HomeModel";
import Loading from "../../Components/Loading";
import { FaCalendarAlt } from "react-icons/fa";

import { IoIosArrowDown, IoIosArrowUp, IoIosCloseCircle } from "react-icons/io";
import { DetailsFormJSon, ValidatorForm2 } from "./LandingPageModel";
import { useDispatch, useSelector } from "react-redux";
import "./Landing.css";
import {
  TEST_BOOKING_FAILED,
  TEST_BOOKING_RESET,
} from "../../Constant/ContactConstant";
import { Helmet } from "react-helmet";

import api from "../../Core/api";
import { MdAccessTimeFilled } from "react-icons/md";
import { IoCall, IoCallOutline } from "react-icons/io5";
import Scroller from "./Scroller";

export default function Webinar() {
  const Navigate = useNavigate();
  const [active, setActive] = useState(null);
  const [DetailsForm, setDetailsForm] = useState({
    ...DetailsFormJSon,
    Amount: "₹ 99.00",
  });

  const [HighlightActive, setHighLightActive] = useState(false);

  const [Auth, setAuth] = useState({
    loading: false,
    success: false,
    error: false,
  });
  const TestmonialRef = useRef();
  const ScrollRef = useRef();
  const dispatch = useDispatch();
  const { loading, success, error } = useSelector((s) => s.Test_Book_Reducer);
  const [index, setIndex] = useState(0);
  const [animationClass, setAnimationClass] = useState("fadeInUp");
  const Heading = [1, 2, 3];

  const [createSec, setcreateSec] = useState(false);

  const handleTaks = (e, num) => {
    e.preventDefault();
    if (HighlightActive == num) {
      setHighLightActive(false);
    } else {
      setHighLightActive(num);
    }
  };

  // /student/cart add cart
  // "packageId": "any",
  // "Timings": "any",
  // "CustomTimings": "any",
  // "classMode": "any",
  // "CourseId": "any"

  // ------

  // /student/cart/withemail add to cart
  // {
  //   "packageId": "any",
  //   "EmailAddress": "any",
  //   "Timings": "any",
  //   "CustomTimings": "any",
  //   "classMode": "any"
  // }

  // /student/order  /student/order/withemail

  // {
  //   "amount": "any",
  //   "PackageId": "any",  //with email EmailAddress:""
  //   "CouponUsed": "any"
  // }

  useEffect(() => {
    const intervalId = setInterval(
      () => {
        setAnimationClass("");
        setIndex((index) => (index + 1) % Heading.length);
        setAnimationClass("fadeInUp");
      },
      5000 // every 5 seconds
    );
    return () => clearTimeout(intervalId);
  }, []);

  const handleToggle = (index) => {
    if (active === index) {
      setActive(null);
    } else {
      setActive(index);
    }
  };

  const handleChange = (e) => {
    if (
      e.target.name == "phone" &&
      (e.target.value?.length > 10 || e.target.value.includes(" "))
    ) {
    } else {
      setDetailsForm({ ...DetailsForm, [e.target.name]: e.target.value });
    }
  };

  const Scroll = () => {
    setcreateSec(true);
  };

  const handleCancel = () => {
    setcreateSec(false);
    setDetailsForm({ ...DetailsFormJSon, Amount: "₹ 99.00" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const Validate = ValidatorForm2(DetailsForm);
    if (Validate == "success") {
      setAuth({ ...Auth, loading: true });
      try {
        const { data } = await api.post("/landing/contact", {
          ...DetailsForm,
          url: window.location.href,
        });
        if (data?.Result) {
          const data2 = await api.post("/student/cart/withemail", {
            packageId: "6793cc90a49569e351d56277", // 6793cc90a49569e351d56277 for production , 67931728339171f954f77854 for staging
            EmailAddress: DetailsForm?.email,
            Timings: "",
            CustomTimings: "",
            classMode: "",
          });

          if (data2?.data?.Result) {
            const data3 = await api.post("/student/order/withemail", {
              amount: 99,
              PackageId: "6793cc90a49569e351d56277", // 6793cc90a49569e351d56277 for production , 67931728339171f954f77854 for staging
              EmailAddress: DetailsForm?.email,
              CouponUsed: "",
            });

            setAuth({ ...Auth, loading: false, success: true });
            if (data3?.data?.Result) {
              window.location.href = data3?.data?.Result;
            }
          }
        }
      } catch (error) {
        setAuth({
          ...Auth,
          loading: false,
          error:
            error.response && error.response.data.Result
              ? error.response.data.Result
              : error.message,
        });
      }
    } else {
      dispatch({ type: TEST_BOOKING_FAILED, payload: Validate });
    }
  };

  useEffect(() => {
    if (Auth.success) {
      setTimeout(() => {
        setDetailsForm({ ...DetailsFormJSon });
        dispatch({ type: TEST_BOOKING_RESET });
      }, 5000);
    }
  }, [Auth.success, dispatch]);

  // useEffect(() => {
  //   setTimeout(() => {
  //     document.getElementById("stat1").classList.add("show");
  //     document.getElementById("JoinStat1").classList.add("show");
  //   }, 500);

  //   setTimeout(() => {
  //     document.getElementById("stat2").classList.add("show");
  //     document.getElementById("JoinStat2").classList.add("show");
  //   }, 1500);

  //   setTimeout(() => {
  //     document.getElementById("stat3").classList.add("show");
  //     document.getElementById("JoinStat3").classList.add("show");
  //   }, 2500);

  //   setTimeout(() => {
  //     document.getElementById("JoinStat4").classList.add("show");
  //   }, 3000);
  // }, []);

  return (
    <>
      <Helmet>
        <meta
          name="title"
          content="Master IELTS with Expert Guidance – Join Our Live Webinar for ₹99"
        />
        <meta
          name="description"
          content="Register for the IELTS & PTE Reality Test to experience a real exam environment, expert feedback, and personalized guidance. just ₹99! Limited slots available."
        />
        <meta
          name="keywords"
          content="IELTS Reality Test, PTE Reality Test, IELTS Mock Test Online, PTE Mock Test 2025, Testifyi IELTS Classes, IELTS Coaching Chandigarh, PTE Coaching Chandigarh, IELTS Exam Preparation, PTE Exam Guidance, ₹99 IELTS Test"
        />
        <meta name="robots" content="index, follow" />
        <meta name="language" content="English" />
        <title>
          Master IELTS with Expert Guidance – Join Our Live Webinar for ₹99
        </title>
        {/* <script type="application/ld+json">
          {`{
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [{
    "@type": "Question",
    "name": "What is TRT: Testifyi Reality Test?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "TRT is a specially designed mock IELTS/PTE test that allows students to: Experience the real IELTS/PTE exam environment. Assess their current skill level. Receive detailed feedback to improve performance in Listening, Reading, Writing, and Speaking"
    }
  },{
    "@type": "Question",
    "name": "What is the cost of the test?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "The test is priced at just ₹99—a highly affordable opportunity to experience a real exam-like environment."
    }
  },{
    "@type": "Question",
    "name": "When and where will the event be conducted?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "The event is scheduled for January 18, 2025, at Nehru Place, Delhi, from 10:00 AM to 5:00 PM."
    }
  },{
    "@type": "Question",
    "name": "What documents should I bring along?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Please bring the following: A valid photo ID (Aadhaar card, passport, or student ID). Your registration confirmation email or message. Basic stationery like pens, pencils, and erasers."
    }
  },{
    "@type": "Question",
    "name": "What is included in the test?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "The test includes all four sections of the IELTS/PTE exam: Listening, Reading, Writing, and Speaking. You’ll get a complete experience of the actual test format."
    }
  },{
    "@type": "Question",
    "name": "When will my Speaking module test be conducted?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "The Speaking test will be conducted on the same day as the event. Specific time slots will be assigned 2 days prior to the test day."
    }
  },{
    "@type": "Question",
    "name": "Will I be notified about my Speaking test time slot?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, your Speaking test time slot will be shared with you 2 days prior to the test day."
    }
  },{
    "@type": "Question",
    "name": "Who can participate in this event?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "This test is ideal for students preparing for IELTS/PTE, whether you're a beginner or looking to refine your skills before the actual exam."
    }
  },{
    "@type": "Question",
    "name": "Will I receive feedback on my performance?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, our IELTS/PTE experts will provide personalized feedback after the test, helping you understand your strengths and areas for improvement."
    }
  },{
    "@type": "Question",
    "name": "How can I register for the test?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Click the [Register Now for ₹99] button, fill in your details, and a Testifyi coordinator will reach out to help you secure your spot."
    }
  },{
    "@type": "Question",
    "name": "What happens if I miss the test?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Unfortunately, the fee is non-refundable. However, you may contact us to explore any future test opportunities."
    }
  }]
}`}
        </script> */}
      </Helmet>

      {/* Header  start*/}

      {loading || Auth.loading ? <Loading /> : ""}

      <header>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: window.innerWidth <= 480 ? "0 20px" : "0 40px",
          }}
        >
          <div>
            <img
              style={{ width: window.innerWidth <= 480 ? "100px" : "150px" }}
              onClick={() => Navigate("/")}
              src="/assets/image/Logos/Testify_White_Logo.svg"
              alt="logo"
            />
          </div>

          <div>
            {window.innerWidth >= 485 ? (
              <div className={Styles.HeaderBtn}>
                <button onClick={() => Scroll()}>Enroll for Rs. 99</button>
                <button onClick={() => Scroll()}>Apply Now</button>
              </div>
            ) : (
              <a style={{ fontSize: "30px" }} href="tel:99990000">
                <IoCall />
              </a>
            )}
          </div>
        </div>
      </header>
      {/* Header end */}

      {/* Banner form Section start */}
      <section className={Styles.MarginNew}>
        <div className={Styles.BannerTop}>
          <div>
            <div id="container2" className={Styles.Top_Webniner2}>
              <div>
                <h3>Uplift - Test Prep Course for IELTS</h3>
              </div>
              <div>
                <p
                  style={{
                    color: "black",
                    padding: "0",
                  }}
                >
                  Intensive Academic IELTS preparation in this advanced,
                  fast-paced course — designed to help you achieve your target
                  band score. Five hours of expert-led training covers all four
                  test sections.
                </p>
              </div>
              <div className={Styles.Top_Date_Wise}>
                <div>
                  <span>Start Date</span>
                  <span>May 5, 2025</span>
                </div>
                <div>
                  <span>Duration</span>
                  <span>5 Days</span>
                </div>
                <div>
                  <span>Course Fee</span>
                  <span>All in just ₹99</span>
                </div>
              </div>
              {window.innerWidth >= 480 ? (
                <>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: "25px",
                    }}
                  >
                    <button
                      className={Styles.CancelBtn2}
                      onClick={() => Scroll()}
                    >
                      I'm Interested
                    </button>
                    <button
                      className={Styles.ActionBtn4}
                      onClick={() => Scroll()}
                    >
                      Apply Now
                    </button>
                  </div>
                  <p className={Styles.Call}>
                    <IoCallOutline /> For enquiries call:{" "}
                    <span style={{ color: "#0b3eff" }}>1800 210 2030 </span>
                  </p>
                </>
              ) : (
                ""
              )}
            </div>
          </div>
          {/* Form Details Start */}
          <div className={Styles.TopBanner_1} ref={ScrollRef}>
            <img
              src="/assets/image/Testifyi-webnier-top.png"
              alt="top_banner"
            />
          </div>

          {/* Form Details end */}
        </div>

        {window.innerWidth < 480 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "column",
              gap: "15px",
              alignItems: "center",

              padding: "10px",
            }}
          >
            <button className={Styles.CancelBtn2} onClick={() => Scroll()}>
              I'm Interested
            </button>
            <button className={Styles.ActionBtn4} onClick={() => Scroll()}>
              Apply Now
            </button>
            <p className={Styles.Call}>
              <IoCallOutline /> For enquiries call:{" "}
              <span style={{ color: "#0b3eff" }}>1800 210 2030 </span>
            </p>
          </div>
        ) : (
          ""
        )}
      </section>
      {/* Banner form Section end */}

      {/* Testimonials start style={{ background: "rgb(255, 241, 245)" }} */}
      <section>
        <div className={Styles.MarginNew2}>
          <div className={Styles.Scroller2}>
            <p>KEY HEIGHLIGHTS</p>
            <h4 style={{ margin: "0", padding: "0",marginBottom:"18px" }}>What You Will Learn</h4>
          </div>

          {window.innerWidth >= 500 ? (
            <div className={Styles.ListingTask}>
              <div className={Styles.Taskes}>
                <div
                  className={
                    HighlightActive == 1 || HighlightActive == false
                      ? Styles.Active
                      : Styles.DeActive
                  }
                  onClick={(e) => handleTaks(e, 1)}
                >
                  <span>Monday</span>
                  <span>Writing Task</span>
                </div>
                <div
                  className={
                    HighlightActive == 2 ? Styles.Active : Styles.DeActive
                  }
                  onClick={(e) => handleTaks(e, 2)}
                >
                  {" "}
                  <span>Tuesday</span>
                  <span>Speaking Task</span>
                </div>
                <div
                  className={
                    HighlightActive == 3 ? Styles.Active : Styles.DeActive
                  }
                  onClick={(e) => handleTaks(e, 3)}
                >
                  <span>Wednesday</span>
                  <span>Reading Task</span>
                </div>

                <div
                  className={
                    HighlightActive == 4 ? Styles.Active : Styles.DeActive
                  }
                  onClick={(e) => handleTaks(e, 4)}
                >
                  <span>Thursday</span>
                  <span>Writing Task</span>
                </div>

                <div
                  className={
                    HighlightActive == 5 ? Styles.Active : Styles.DeActive
                  }
                  onClick={(e) => handleTaks(e, 5)}
                >
                  <span>Friday</span>
                  <span>Writing Task</span>
                </div>
              </div>
              <div>
                {HighlightActive == 1 || HighlightActive == false ? (
                  <div style={{ padding: " 0px 20px" }}>
                    <p>
                      <b>Topic:</b> Writing Task (Essay Writing)
                    </p>

                    <p>
                      <b>Duration:</b> 1 Hour
                    </p>
                    <p>Learn to craft well-structured essays for IELTS exam.</p>
                    <p>
                      <b>Topics Covered</b>
                    </p>
                    <ul>
                      <li>Various Essay Themes</li>
                      <li>Marking Criteria</li>
                      <li>Writing Techniques</li>
                    </ul>
                  </div>
                ) : HighlightActive == 2 ? (
                  <div style={{ padding: " 0px 20px" }}>
                    <p>
                      <b>Topic:</b> Speaking Task (Eassy Speaking)
                    </p>

                    <p>
                      <b>Duration:</b> 1 Hour
                    </p>
                    <p>Learn to craft well-structured essays for IELTS exam.</p>
                    <p>
                      <b>Topics Covered</b>
                    </p>
                    <ul>
                      <li>Various Essay Themes</li>
                      <li>Marking Criteria</li>
                      <li>Writing Techniques</li>
                    </ul>
                  </div>
                ) : HighlightActive == 3 ? (
                  <div style={{ padding: " 0px 20px" }}>
                    <p>
                      <b>Topic:</b> Writing Task (Essay Writing)
                    </p>

                    <p>
                      <b>Duration:</b> 1 Hour
                    </p>
                    <p>Learn to craft well-structured essays for IELTS exam.</p>
                    <p>
                      <b>Topics Covered</b>
                    </p>
                    <ul>
                      <li>Various Essay Themes</li>
                      <li>Marking Criteria</li>
                      <li>Writing Techniques</li>
                    </ul>
                  </div>
                ) : HighlightActive == 4 ? (
                  <div style={{ padding: " 0px 20px" }}>
                    <p>
                      <b>Topic:</b> Writing Task (Essay Writing)
                    </p>

                    <p>
                      <b>Duration:</b> 1 Hour
                    </p>
                    <p>Learn to craft well-structured essays for IELTS exam.</p>
                    <p>
                      <b>Topics Covered</b>
                    </p>
                    <ul>
                      <li>Various Essay Themes</li>
                      <li>Marking Criteria</li>
                      <li>Writing Techniques</li>
                    </ul>
                  </div>
                ) : (
                  <div style={{ padding: " 0px 20px" }}>
                    <p>
                      <b>Topic:</b> Writing Task (Essay Writing)
                    </p>

                    <p>
                      <b>Duration:</b> 1 Hour
                    </p>
                    <p>Learn to craft well-structured essays for IELTS exam.</p>
                    <p>
                      <b>Topics Covered</b>
                    </p>
                    <ul>
                      <li>Various Essay Themes</li>
                      <li>Marking Criteria</li>
                      <li>Writing Techniques</li>
                    </ul>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className={Styles.KeyHighlight}>
              <div>
                <div onClick={(e) => handleTaks(e, 1)}>
                  {" "}
                  <p>Writing Task</p>
                  {HighlightActive == 1 ? (
                    <p style={{ color: "#0b3eff" }}>
                      <IoIosArrowUp />
                    </p>
                  ) : (
                    <p>
                      <IoIosArrowDown />
                    </p>
                  )}
                </div>
                {HighlightActive == 1 ? (
                  <div>
                    <hr className={Styles.Hrnew} />
                    <div>
                      <p>
                        <b>Topic:</b> Writing Task (Essay Writing)
                      </p>

                      <p>
                        <b>Duration:</b> 1 Hour
                      </p>
                      <p>
                        Learn to craft well-structured essays for IELTS exam.
                      </p>
                      <p>
                        <b>Topics Covered</b>
                      </p>
                      <ul>
                        <li>Various Essay Themes</li>
                        <li>Marking Criteria</li>
                        <li>Writing Techniques</li>
                      </ul>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div>
                <div onClick={(e) => handleTaks(e, 2)}>
                  <p>Speaking Task</p>{" "}
                  {HighlightActive == 2 ? (
                    <p style={{ color: "#0b3eff" }}>
                      <IoIosArrowUp />
                    </p>
                  ) : (
                    <p>
                      <IoIosArrowDown />
                    </p>
                  )}
                </div>

                {HighlightActive == 2 ? (
                  <div>
                    <hr className={Styles.Hrnew} />
                    <div>
                      <p>
                        <b>Topic:</b> Writing Task (Essay Writing)
                      </p>

                      <p>
                        <b>Duration:</b> 1 Hour
                      </p>
                      <p>
                        Learn to craft well-structured essays for IELTS exam.
                      </p>
                      <p>
                        <b>Topics Covered</b>
                      </p>
                      <ul>
                        <li>Various Essay Themes</li>
                        <li>Marking Criteria</li>
                        <li>Writing Techniques</li>
                      </ul>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div>
                <div onClick={(e) => handleTaks(e, 3)}>
                  <p>Reading Task</p>{" "}
                  {HighlightActive == 3 ? (
                    <p style={{ color: "#0b3eff" }}>
                      <IoIosArrowUp />
                    </p>
                  ) : (
                    <p>
                      <IoIosArrowDown />
                    </p>
                  )}
                </div>

                {HighlightActive == 3 ? (
                  <div>
                    <hr className={Styles.Hrnew} />
                    <div>
                      <p>
                        <b>Topic:</b> Writing Task (Essay Writing)
                      </p>

                      <p>
                        <b>Duration:</b> 1 Hour
                      </p>
                      <p>
                        Learn to craft well-structured essays for IELTS exam.
                      </p>
                      <p>
                        <b>Topics Covered</b>
                      </p>
                      <ul>
                        <li>Various Essay Themes</li>
                        <li>Marking Criteria</li>
                        <li>Writing Techniques</li>
                      </ul>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div>
                <div onClick={(e) => handleTaks(e, 4)}>
                  <p>Writing Task</p>{" "}
                  {HighlightActive == 4 ? (
                    <p style={{ color: "#0b3eff" }}>
                      <IoIosArrowUp />
                    </p>
                  ) : (
                    <p>
                      <IoIosArrowDown />
                    </p>
                  )}
                </div>

                {HighlightActive == 4 ? (
                  <div>
                    <hr className={Styles.Hrnew} />
                    <div>
                      <p>
                        <b>Topic:</b> Writing Task (Essay Writing)
                      </p>

                      <p>
                        <b>Duration:</b> 1 Hour
                      </p>
                      <p>
                        Learn to craft well-structured essays for IELTS exam.
                      </p>
                      <p>
                        <b>Topics Covered</b>
                      </p>
                      <ul>
                        <li>Various Essay Themes</li>
                        <li>Marking Criteria</li>
                        <li>Writing Techniques</li>
                      </ul>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
              <div>
                <div onClick={(e) => handleTaks(e, 5)}>
                  <p>Listening </p>{" "}
                  {HighlightActive == 5 ? (
                    <p style={{ color: "#0b3eff" }}>
                      <IoIosArrowUp />
                    </p>
                  ) : (
                    <p>
                      <IoIosArrowDown />
                    </p>
                  )}
                </div>

                {HighlightActive == 5 ? (
                  <div>
                    <hr className={Styles.Hrnew} />
                    <div>
                      <p>
                        <b>Topic:</b> Writing Task (Essay Writing)
                      </p>

                      <p>
                        <b>Duration:</b> 1 Hour
                      </p>
                      <p>
                        Learn to craft well-structured essays for IELTS exam.
                      </p>
                      <p>
                        <b>Topics Covered</b>
                      </p>
                      <ul>
                        <li>Various Essay Themes</li>
                        <li>Marking Criteria</li>
                        <li>Writing Techniques</li>
                      </ul>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          )}
        </div>
      </section>
      {/* Testimonials end */}

      {/* Testimonials start */}
      <section style={{ background: "white", padding: "20px 0" }}>
        <div className={Styles.MarginNew2}>
          <div className={Styles.Scroller2}>
            <h4 style={{ margin: "0", padding: "0" }}>
              Why should you choose Uplift - Test Prep
              {window.innerWidth >= 480 ? <br /> : ""} Course for IELTS?
            </h4>
            <p>
              Testifyi offers end-to-end solution and exclusive benefits{" "}
              {window.innerWidth >= 480 ? <br /> : ""} for study abroad
              aspirants, including:
            </p>
          </div>

          <Scroller />
          <div className={Styles.Center}>
            <button className={Styles.ActionBtn} onClick={() => Scroll()}>
              Join the webinar today
            </button>
          </div>
        </div>
      </section>
      {/* Testimonials end */}

      {/* Testimonials start */}
      <section style={{ background: "#f4f9ff", padding: "10px 0" }}>
        <div className={Styles.MarginNew2}>
          <div>
            <h1 className={Styles.Heading}>
              <span className={Styles.Font_Rajdhani}>
                {" "}
                Hear From Our Students
              </span>
            </h1>
          </div>
          <Testimonial
            TestmonialRef={TestmonialRef}
            Testimonials_Model={Testimonials_Model}
          />
          <div className={Styles.Center}>
            <button className={Styles.ActionBtn} onClick={() => Scroll()}>
              Join the webinar today
            </button>
          </div>{" "}
        </div>
      </section>
      {/* Testimonials end */}

      <section>
        <div className={Styles.CoupnImage}>
          <div>
            <img src="/assets/image/99Coupn.webp" alt="99" />
          </div>
          <div>
            <div>
              <h3>Ace Your IELTS Exam: Expert-Led Program</h3>
              <p>
                Maximum returns with a minimum investment of ₹99 on this quick
                and effective IELTS preparatory course! Get ready for your study
                abroad adventure!
              </p>
            </div>
            <div>
              <button
                className={
                  window.innerWidth <= 480
                    ? Styles.ActionBtn4
                    : Styles.ActionBtn
                }
                onClick={() => Scroll()}
              >
                Explore Now
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* FAQs satrt */}
      <section style={{ background: "#ffffff" }} className=".Faqs">
        <div className={Styles.MarginNew2}>
          <div className="container-fluid mt-5 mb-5">
            <div className="card-body_Faq">
              <div className={Styles.Form_Heading}>
                <h1 className="">
                  Frequently Asked{" "}
                  <span style={{ color: "#0b3eff" }}>Questions</span>
                </h1>
                <p style={{ textAlign: "center" }}>
                  Got Questions? We’ve Got Answers!
                </p>
              </div>
              <div className="FAQ_ALL">
                {FAQS_TRT2.map((faq, index) => {
                  return (
                    <AccordionItem
                      key={index}
                      active={active}
                      handleToggle={handleToggle}
                      faq={faq}
                    />
                  );
                })}
              </div>
              {/* <div className={Styles.Center}>
                <button className={Styles.ActionBtn} onClick={() => Scroll()}>
                  Join the Test Today
                </button>
              </div> */}
            </div>
          </div>
        </div>
      </section>
      {/* FAQs end */}

      {/* Payment Form start */}

      {createSec ? (
        <div
          id="CreatContact"
          style={{ width: "100%" }}
          className={"overlay-note middle-hand w100 BookDemo Payment_landing"}
        >
          <div className="container" id="booking-container">
            <h1>Register Now to Master Your IELTS Score</h1>
            <div onClick={() => handleCancel()} className="closeBtn_Book">
              <span>
                <IoIosCloseCircle />
              </span>
            </div>
            <form
              id="appointment-form"
              onSubmit={handleSubmit}
              className="Form_Appointment landingPayment"
            >
              {/* <div>
                <div className="form-group">
                  <label for="amount">Amount</label>
                  <input
                    id="amount"
                    className="Amount99"
                    type="text"
                    name="Amount"
                    value={DetailsForm?.Amount}
                    disabled={true}
                    onChange={(e) => handleChange(e)}
                    required
                  />
                </div>
              </div> */}

              <div>
                <div className="form-group">
                  <label for="name">Name</label>
                  <input
                    id="name"
                    type="text"
                    name="name"
                    value={DetailsForm?.name}
                    onChange={(e) => handleChange(e)}
                    required
                  />
                </div>
              </div>

              <div>
                <div className="form-group">
                  <label for="email">Email Address</label>
                  <input
                    id="email"
                    type="email"
                    name="email"
                    value={DetailsForm?.email}
                    onChange={(e) => handleChange(e)}
                    required
                  />
                </div>
              </div>

              <div>
                <div className="form-group">
                  <label for="phone">Phone No</label>
                  <input
                    type="number"
                    id="phone"
                    name="phone"
                    value={DetailsForm?.phone}
                    onChange={(e) => handleChange(e)}
                    required
                  />
                </div>
              </div>
              <div>
                {error || Auth.error ? (
                  <p style={{ color: "red" }}> {error || Auth.error}</p>
                ) : Auth?.success ? (
                  <p style={{ color: "green" }}>{Auth?.success}</p>
                ) : (
                  ""
                )}
              </div>

              <div className="Fotter_payment">
                <div>
                  {/* <img
                    src="/assets/image/pay_methods_branding.png"
                    alt="pay_methods_branding"
                  /> */}
                </div>
                <div className="Book_A_demo_btn">
                  <button type="submit" disabled={loading}>
                    {loading ? "Loading..." : "REGISTER AND PAY"}
                  </button>
                </div>
              </div>
              {/* <div
                className="Safe_Secure"
                style={{ padding: "0", margin: "0" }}
              >
                <p style={{ paddingTop: "8px", margin: "0" }}>
                  <span>
                    <AiFillSafetyCertificate />
                  </span>
                  <span>Safe and Secure Payments 100%.</span>
                </p>
              </div> */}
            </form>
          </div>
        </div>
      ) : (
        ""
      )}

      {/* Payment Form end */}

      {/* Footer start */}
      <footer className={Styles.Footer} style={{ marginBottom: "80px" }}>
        <div>
          {/* <div>
            <div>
              <img
                onClick={() => Navigate("/")}
                src="/assets/image/Logos/Testifyi_logo1.jpg"
                alt="logo"
              />
              <p>
                Facilitating students acquire perfect-fit education placements
                that ultimately changes their lives!
              </p>

         
            </div>
            <hr className={Styles.Hr1} />
            <div>
              <h3>My Profile</h3>
              <p onClick={() => Navigate("/signup", { replace: true })}>
                Create Account
              </p>
              <p onClick={() => Navigate("/login", { replace: true })}>
                Login Now
              </p>
              <p onClick={() => Navigate("/contact-us")}>Contact Us</p>{" "}
              <p onClick={() => Navigate("/about-us")}>About Us</p>
            </div>
            <hr className={Styles.Hr1} />
            <div>
              <h3>Important Links</h3>
              <p onClick={() => Navigate("/Course")}>Our Courses</p>
           
              <p onClick={() => Navigate("/dashboard")}>Dashboard</p>
              <p onClick={() => Navigate("/terms-and-conditions")}>
                Terms And Conditions
              </p>
              <p onClick={() => Navigate("/privacy-policy")}>Privacy Policy</p>
            </div>
            <hr className={Styles.Hr1} />
            <div>
              <h3>Contact Us</h3>
              <p style={{ display: "flex", gap: "8px", fontSize: "13px" }}>
                <span style={{ color: "white" }}>
                  <IoHomeOutline />{" "}
                </span>

                <span style={{ fontSize: "14px" }}>
                  Address : 1409-1412, 14th Floor, 38, Ansal Tower, Nehru Place,
                  New Delhi, Delhi 110019
                </span>
              </p>

              <p style={{ display: "flex", gap: "8px", fontSize: "13px" }}>
                <span style={{ color: "white" }}>
                  <IoIosCall />
                </span>
                <span style={{ fontSize: "14px" }}>+91 92891 92873</span>
              </p>
              <p style={{ display: "flex", gap: "8px", fontSize: "13px" }}>
                <span style={{ color: "white" }}>
                  <FaMapMarkedAlt />{" "}
                </span>

                <span style={{ fontSize: "14px" }}>
                  Map :{" "}
                  <a
                    href="https://maps.app.goo.gl/74ufjPk837JUPDcq8"
                    target="_blank"
                    rel="noreferrer"
                    style={{ textDecoration: "none" }}
                  >
                    Locate Us{" "}
                  </a>
                </span>
              </p>
              
              <p
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginTop: "-20px",
                }}
              >
                Follow Us :{" "}
                <p style={{ display: "flex", gap: "8px", color: "white" }}>
                  <span
                    onClick={() =>
                      window.open(
                        "https://www.instagram.com/testifyi.india?igsh=c3ZpN2N2ZDg4cWVm"
                      )
                    }
                  >
                    <PiInstagramLogoBold />
                  </span>
                  <span
                    onClick={() =>
                      window.open(
                        "https://www.facebook.com/testifyi.india?mibextid=LQQJ4d"
                      )
                    }
                  >
                    <RiFacebookFill />
                 
                </p>{" "}
              </p>

              
            </div>
          </div> */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            <h4 style={{ textAlign: "center" }}>Disclaimer</h4>
            <p>
              The information provided in this IELTS webinar and course is for
              educational purposes only and should not be considered as
              personalized test preparation advice. While we strive to offer the
              most effective strategies and tips, individual results may vary.
              For personalized coaching and study plans, please consult with our
              certified trainers or academic counselors.
            </p>
          </div>

          <div>
            <hr className={Styles.Hr2} />
            <p onClick={() => Navigate("/")}>
              @ 2025 Testifyi.com All Rights Reserved.
            </p>
          </div>
        </div>
      </footer>

      {/* Footer end */}

      {/* Bottom Fixed banner */}
      <section className={Styles.BootmFixedBanner}>
        <div>
          <div>
            <h4>
              <span>₹ 99</span> <span> ₹ 499</span>
            </h4>
            <p>
              Fri, 02<sup>nd</sup> May, 7 PM
            </p>
          </div>
          <div>
            <button onClick={() => Scroll()}>Register Now</button>
          </div>
        </div>
      </section>
      {/* Bottom Fixed banner */}
    </>
  );
}
